import React, { createContext, useContext, useState } from 'react';

// Language content - Ukrainian as primary
const content = {
  UA: {
    // Navigation
    nav: {
      philosophy: 'Про нас',
      projects: 'Проєкти',
      projectBuilder: 'Конструктор проєкту',
      process: 'Процес',
      contact: 'Контакт',
      cta: 'Зв\u2019язатися',
    },
    // Hero - Specific, Architectural
    hero: {
      label: 'Архітектура та дизайн інтер\'єру',
      headline: 'Проєктуємо простори від концепції до реалізації',
      /** Editorial line breaks for h1 (cinematic hierarchy). */
      headlineLines: ['Проєктуємо простори', 'від концепції до реалізації'],
      subheadline: 'з повним авторським супроводом',
      description: 'Приватні резиденції, комерційні об\'єкти та громадські простори. Від першого ескізу до ключів — ваш проєкт під нашим контролем.',
      cta: 'Зв\u2019язатися',
      ctaSecondary: 'Дивитися проєкти',
      scroll: 'Прокрутити',
    },
    // What We Do (About Section)
    about: {
      label: 'Що ми робимо',
      headline: 'Архітектура та дизайн',
      headlineItalic: 'як єдина система',
      description: 'Ми не розділяємо архітектуру та інтер\'єр — вони працюють разом. Кожен проєкт проходить повний цикл: від концепції до здачі об\'єкта з авторським наглядом.',
      services: [
        {
          id: 'architecture',
          title: 'Архітектура',
          description: 'Проєктування будинків, вілл та комерційних об\'єктів. Від концепції до робочої документації.',
        },
        {
          id: 'interior',
          title: 'Дизайн інтер\'єру',
          description: 'Комплексний дизайн простору: планування, матеріали, меблі, освітлення.',
        },
        {
          id: 'supervision',
          title: 'Авторський нагляд',
          description: 'Контроль реалізації на всіх етапах будівництва. Ваш проєкт буде втілений точно.',
        },
        {
          id: 'visualization',
          title: '3D візуалізація',
          description: 'Фотореалістичні візуалізації для повного розуміння майбутнього простору.',
        },
      ],
    },
    // Projects
    projects: {
      label: 'Проєкти',
      headline: 'Вибрані',
      headlineItalic: 'роботи',
      viewAll: 'Усі проєкти',
    },
    // Team
    team: {
      label: 'Команда',
      headline: 'Люди',
      headlineItalic: 'SATI',
      foundersLabel: 'Засновники',
      teamLabel: 'Команда',
      foundersPhoto: 'https://customer-assets.emergentagent.com/job_dd08d3a8-7b2f-4937-a4f8-1a2714b3732e/artifacts/1qfgy354_two.jpg',
      founders: [
        { id: 'taras', name: 'Тарас', role: 'Співзасновник, CEO' },
        { id: 'oleksandr', name: 'Олександр', role: 'Співзасновник, Головний архітектор' },
      ],
      members: [
        {
          id: 'pavlo',
          name: 'Павло',
          role: 'Архітектор, керівник проєктів',
          photo: 'https://customer-assets.emergentagent.com/job_dd08d3a8-7b2f-4937-a4f8-1a2714b3732e/artifacts/vfjgg8by_3%20Pavlo.jpg',
        },
        {
          id: 'mariya',
          name: 'Марія',
          role: 'Дизайнер інтер\'єру',
          photo: 'https://customer-assets.emergentagent.com/job_dd08d3a8-7b2f-4937-a4f8-1a2714b3732e/artifacts/7uw7xizy_4%20Mariya.jpg',
        },
        {
          id: 'anastasia',
          name: 'Анастасія',
          role: 'Дизайнер інтер\'єру',
          photo: 'https://customer-assets.emergentagent.com/job_dd08d3a8-7b2f-4937-a4f8-1a2714b3732e/artifacts/lh4lccgo_5%20Anastasia.JPG',
        },
        {
          id: 'kseniia',
          name: 'Ксенія',
          role: '3D візуалізатор',
          photo: 'https://customer-assets.emergentagent.com/job_dd08d3a8-7b2f-4937-a4f8-1a2714b3732e/artifacts/3youxc4v_6%20Kseniia.JPG',
        },
        {
          id: 'viktor',
          name: 'Віктор',
          role: 'Архітектор',
          photo: 'https://customer-assets.emergentagent.com/job_dd08d3a8-7b2f-4937-a4f8-1a2714b3732e/artifacts/qfcehzeq_7%20Victor.PNG',
        },
      ],
    },
    // Process
    process: {
      label: 'Процес',
      headline: 'Як ми',
      headlineItalic: 'працюємо',
      description: 'Кожен проєкт проходить чіткий шлях від першої зустрічі до ключів.',
      cta1: 'Почати консультацію',
      cta2: 'Обговорити проєкт',
      steps: [
        { number: '01', title: 'Консультація', description: 'Знайомство, обговорення бачення та бюджету' },
        { number: '02', title: 'Концепція', description: 'Створення архітектурної ідеї та планувальних рішень' },
        { number: '03', title: 'Проєктування', description: 'Детальна розробка документації та візуалізацій' },
        { number: '04', title: 'Реалізація', description: 'Авторський нагляд на всіх етапах будівництва' },
      ],
    },
    // Contact
    contact: {
      label: 'Контакт',
      headline: 'Готові почати',
      headlineItalic: 'діалог?',
      description: 'Розкажіть про ваш проєкт — ми підготуємо індивідуальну пропозицію.',
      form: {
        name: 'Ваше ім\'я',
        email: 'Email',
        phone: 'Телефон',
        projectType: 'Тип проєкту',
        message: 'Опишіть ваш проєкт',
        submit: 'Надіслати запит',
        sending: 'Надсилання...',
        success: 'Дякуємо',
        successMessage:
          'Запит прийнято. Команда студії отримає ваше повідомлення та зв’яжеться з вами протягом робочого дня. Якщо питання термінове — зателефонуйте або напишіть у Telegram.',
      },
      projectTypes: ['Приватний будинок', 'Квартира', 'Комерційний об\'єкт', 'Інше'],
      email: 'Пошта',
      phone: 'Телефон',
      locations: 'Локації',
      cta: 'Або зателефонуйте нам',
    },
    // Floating contact tray (YouRock-style entry)
    contactPush: {
      fab: 'Обговорити проєкт',
      close: 'Закрити',
      closeFab: 'Згорнути',
      kicker: 'Швидкий контакт',
      title: 'Обговорити проєкт',
      telegram: 'Telegram',
      form: 'Форма запиту',
    },
    // Footer
    footer: {
      description: 'Міжнародна студія архітектури та дизайну.',
      connect: 'Зв\'язок',
      privacy: 'Конфіденційність',
      terms: 'Умови',
    },
  },
  EN: {
    // Navigation
    nav: {
      philosophy: 'About',
      projects: 'Projects',
      projectBuilder: 'Project builder',
      process: 'Process',
      contact: 'Contact',
      cta: 'Contact',
    },
    // Hero - Specific, Architectural
    hero: {
      label: 'Architecture & Interior Design',
      headline: 'We design spaces from concept to completion',
      headlineLines: ['We design spaces', 'from concept to completion'],
      subheadline: 'with full author supervision',
      description: 'Private residences, commercial facilities, and public spaces. From first sketch to keys — your project under our control.',
      cta: 'Get in touch',
      ctaSecondary: 'View work',
      scroll: 'Scroll',
    },
    // What We Do (About Section)
    about: {
      label: 'What We Do',
      headline: 'Architecture & design',
      headlineItalic: 'as one system',
      description: 'We don\'t separate architecture and interior — they work together. Every project goes through a full cycle: from concept to completion with author supervision.',
      services: [
        {
          id: 'architecture',
          title: 'Architecture',
          description: 'Design of houses, villas, and commercial facilities. From concept to working documentation.',
        },
        {
          id: 'interior',
          title: 'Interior Design',
          description: 'Comprehensive space design: planning, materials, furniture, lighting.',
        },
        {
          id: 'supervision',
          title: 'Author Supervision',
          description: 'Implementation control at all construction stages. Your project will be realized precisely.',
        },
        {
          id: 'visualization',
          title: '3D Visualization',
          description: 'Photorealistic visualizations for complete understanding of future space.',
        },
      ],
    },
    // Projects
    projects: {
      label: 'Projects',
      headline: 'Selected',
      headlineItalic: 'works',
      viewAll: 'All Projects',
    },
    // Team
    team: {
      label: 'Team',
      headline: 'People of',
      headlineItalic: 'SATI',
      foundersLabel: 'Founders',
      teamLabel: 'Team',
      foundersPhoto: 'https://customer-assets.emergentagent.com/job_dd08d3a8-7b2f-4937-a4f8-1a2714b3732e/artifacts/1qfgy354_two.jpg',
      founders: [
        { id: 'taras', name: 'Taras', role: 'Co-Founder, CEO' },
        { id: 'oleksandr', name: 'Oleksandr', role: 'Co-Founder, Chief Architect' },
      ],
      members: [
        {
          id: 'pavlo',
          name: 'Pavlo',
          role: 'Architect, Project Lead',
          photo: 'https://customer-assets.emergentagent.com/job_dd08d3a8-7b2f-4937-a4f8-1a2714b3732e/artifacts/vfjgg8by_3%20Pavlo.jpg',
        },
        {
          id: 'mariya',
          name: 'Mariya',
          role: 'Interior Designer',
          photo: 'https://customer-assets.emergentagent.com/job_dd08d3a8-7b2f-4937-a4f8-1a2714b3732e/artifacts/7uw7xizy_4%20Mariya.jpg',
        },
        {
          id: 'anastasia',
          name: 'Anastasia',
          role: 'Interior Designer',
          photo: 'https://customer-assets.emergentagent.com/job_dd08d3a8-7b2f-4937-a4f8-1a2714b3732e/artifacts/lh4lccgo_5%20Anastasia.JPG',
        },
        {
          id: 'kseniia',
          name: 'Kseniia',
          role: '3D Visualizer',
          photo: 'https://customer-assets.emergentagent.com/job_dd08d3a8-7b2f-4937-a4f8-1a2714b3732e/artifacts/3youxc4v_6%20Kseniia.JPG',
        },
        {
          id: 'viktor',
          name: 'Viktor',
          role: 'Architect',
          photo: 'https://customer-assets.emergentagent.com/job_dd08d3a8-7b2f-4937-a4f8-1a2714b3732e/artifacts/qfcehzeq_7%20Victor.PNG',
        },
      ],
    },
    // Process
    process: {
      label: 'Process',
      headline: 'How we',
      headlineItalic: 'work',
      description: 'Every project follows a clear path from first meeting to keys.',
      cta1: 'Start Consultation',
      cta2: 'Discuss Project',
      steps: [
        { number: '01', title: 'Consultation', description: 'Introduction, discussion of vision and budget' },
        { number: '02', title: 'Concept', description: 'Creating architectural idea and planning solutions' },
        { number: '03', title: 'Design', description: 'Detailed development of documentation and visualizations' },
        { number: '04', title: 'Implementation', description: 'Author supervision at all construction stages' },
      ],
    },
    // Contact
    contact: {
      label: 'Contact',
      headline: 'Ready to start',
      headlineItalic: 'a dialogue?',
      description: 'Tell us about your project — we\'ll prepare an individual proposal.',
      form: {
        name: 'Your Name',
        email: 'Email',
        phone: 'Phone',
        projectType: 'Project Type',
        message: 'Describe your project',
        submit: 'Send Request',
        sending: 'Sending...',
        success: 'Thank You',
        successMessage:
          'Your request is in. Our studio will receive it and reply within one business day. If your matter is urgent, call or message us on Telegram.',
      },
      projectTypes: ['Private House', 'Apartment', 'Commercial', 'Other'],
      email: 'Email',
      phone: 'Phone',
      locations: 'Locations',
      cta: 'Or call us',
    },
    // Floating contact tray
    contactPush: {
      fab: 'Discuss project',
      close: 'Close',
      closeFab: 'Minimize',
      kicker: 'Quick contact',
      title: 'Discuss your project',
      telegram: 'Telegram',
      form: 'Request form',
    },
    // Footer
    footer: {
      description: 'International architecture and design studio.',
      connect: 'Connect',
      privacy: 'Privacy',
      terms: 'Terms',
    },
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('UA');
  
  const toggleLanguage = (lang) => {
    if (lang) {
      setLanguage(lang);
    } else {
      setLanguage(prev => prev === 'UA' ? 'EN' : 'UA');
    }
  };

  const t = content[language];

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export default LanguageContext;
